/* unplugin-vue-components disabled */import { render } from "./Classification.vue?vue&type=template&id=ee9b75c8&scoped=true"
import script from "./Classification.vue?vue&type=script&lang=js"
export * from "./Classification.vue?vue&type=script&lang=js"

import "./Classification.vue?vue&type=style&index=0&id=ee9b75c8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9b75c8"]])

export default __exports__